function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#FFF",
  d: "M20.5 39l.7 1.1c0 .3.3.4.6.4.2 0 .5-.2.6-.4l.6-1.2c.7-1.5 1-3.2 1-5l-.8-21.4a15 15 0 0 0-.7-4.3l-2-5.3-1.7 5.5c-.4 1.4-.5 2.8-.5 4.2l.8 21.6c0 1.6.5 3.3 1.4 4.8z"
}), React.createElement("path", {
  fill: "#46C3D7",
  d: "M20.4 37v.2l1.2.6h.2a1.4 1.4 0 0 0 1.1-.9l.2-.6h-.2l-.2.4-.2.1-.7.4h-.2c-.3 0-.6-.1-.8-.3l-.2-.1-.2-.4h-.2c0 .2 0 .4.2.6"
}), React.createElement("path", {
  fill: "#145569",
  d: "M27.4 26.9a7 7 0 0 0 2-.1h.4l-.3-2v-1c0-.3-.4-.7-.8-.6H28c-.5 0-.8.3-.8.7v3h.2z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M27.3 27.4h.1a7 7 0 0 0 2 0h.2l.2-.3v-.3h-.4a7 7 0 0 1-2 0h-.3v.4c0 .1 0 .2.2.2M32 24.2h.1a7 7 0 0 0 2 0h.2l.1-.3v-.3h-.3a7 7 0 0 1-2 0l-.3.1v.3c0 .2 0 .2.2.2"
}), React.createElement("path", {
  fill: "#145569",
  d: "M32.1 23.7a7 7 0 0 0 2 0h.3l-.2-2.3v-.7c0-.4-.4-.8-.8-.7h-.7c-.4 0-.8.3-.8.7v3h.2zM15.2 27.3h-2.3v-3c0-.3.4-.7.8-.7h.7c.4 0 .8.3.8.7l.3 2.6v.4h-.3z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M15.4 27.8H13a.2.2 0 0 1-.2-.1v-.3h2.3l.3-.1v.3l-.1.2M10.5 25H8.2c-.1 0-.2 0-.2-.2v-.3H10.6v.3l-.1.2M10.3 24.5H8v-3c0-.4.4-.7.8-.7h.7c.4 0 .8.2.8.7l.2 2.3v.6h-.2z"
}), React.createElement("path", {
  fill: "#E66E0A",
  d: "M41.3 13.7L25.9 19l-2.4.8.3 8.5 2.3-1.7 14.5-10.4z"
}), React.createElement("path", {
  fill: "#F3C09E",
  d: "M40.6 16.3L23.8 28.4v-1l17.1-12.3z"
}), React.createElement("path", {
  fill: "#E66E0A",
  d: "M.5 15.1l15.8 4.4 2.3.6.3 8.5-2.4-1.5-15.2-9.4z"
}), React.createElement("path", {
  fill: "#F3C09E",
  d: "M1.3 17.7l17.6 10.9v-1.1l-18-11z"
}), React.createElement("path", {
  fill: "#E66E0A",
  d: "M13.1 1L18 3l2.2.7v4.5l-2-1.6-4.8-4z"
}), React.createElement("path", {
  fill: "#F3C09E",
  d: "M13.4 2.6L20.3 8v-.8l-7-5.6z"
}), React.createElement("path", {
  fill: "#E66E0A",
  d: "M27.7.6L23 2.7l-2.2.9.3 4.5 2-1.8 4.5-4.2z"
}), React.createElement("path", {
  fill: "#F3C09E",
  d: "M27.6 2L21 8v-.7l6.5-6.1z"
}), React.createElement("path", {
  fill: "#F3C09E",
  d: "M20.7 10a.5.5 0 0 0 .5-.5L20.6.7a.2.2 0 0 0-.2-.2l-.2.2v8.8a.4.4 0 0 0 .5.5z"
}));

var SvgPlane3 = function SvgPlane3(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 42 41",
    width: 42,
    height: 41,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlane3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plane3.ffbc1c9b.svg";
export { ForwardRef as ReactComponent };